import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import { ArrowDropDown, ArrowDropDownCircleOutlined, NotificationsOutlined } from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';
import { IconButton } from "@material-ui/core";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import { useAuth } from '../context/AuthContext';
import { Accordion, AccordionDetails, AccordionSummary, Badge, Box, Popover } from '@mui/material';
import AppContext from '../context/AppContext';

const styles = ({ spacing, transitions, breakpoints, palette, shape }) => ({
    header: {
        fontWeight: 900,
        minWidth: 0,
        fontSize: 18,
        color: '#ffffff'
    },
    grow: {
        flexGrow: 1,
    },
    search: {
        position: 'relative',
        marginRight: 8,
        borderRadius: '12px',
        background: palette.grey[200],
        '&:hover': {
            background: palette.grey[300],
        },
        marginLeft: 0,
        width: '100%',
        [breakpoints.up('sm')]: {
            marginLeft: spacing(1),
            width: 'auto',
        },
    },
    searchIcon: {
        width: spacing(7),
        height: '100%',
        borderRadius: '12px 0px 0px 12px',
        color: '#ffffff',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#50c1e9',
        justifyContent: 'center',
    },
    avatar: {
        backgroundColor: '#50c1e9',
        width: 35,
        height: 35
    },
    inputRoot: {
        color: '#60636c',
        width: '100%',
    },
    inputInput: {
        borderRadius: 4,
        paddingTop: spacing(1),
        paddingRight: spacing(1),
        paddingBottom: spacing(1),
        paddingLeft: spacing(8),
        transition: transitions.create('width'),
        width: '100%',
        [breakpoints.up('sm')]: {
            width: 120,
            '&:focus': {
                width: 200,
            },
        },
    },
    popover: {
        padding: spacing(2),
        maxWidth: 500,
        backgroundColor: '#f9f9f9',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
    },
    popoverTitle: {
        fontWeight: 700,
        marginBottom: spacing(1),
        color: '#333',
    },
    popoverContent: {
        fontSize: '0.875rem',
        color: '#555',
    },
});

const PrivateHeader = ({ classes }) => {
    const { socketData, notification } = useContext(AppContext);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleBadgeClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    let history = useHistory();
    const { logout, currentUser } = useAuth();
    console.log(currentUser, "current user")
    const handleLogout = async () => {
        try {
            await logout();
            history.push('/');
        } catch {
            console.log("Failed to logout");
        }
    };

    return (
        <>
            <Typography noWrap color={'textSecondary'} className={classes.header}>
            GayaT
            </Typography>
            <div className={classes.grow} />
            {/* <div className={classes.search}>
                <div className={classes.searchIcon}>
                    <SearchIcon style={{ width: 25, height: 30 }} />
                </div>
                <InputBase
                    placeholder="Search…"
                    classes={{
                        root: classes.inputRoot,
                        input: classes.inputInput,
                    }}
                />
            </div> */}
            <div style={{ paddingRight: 12 }}>
                <Badge badgeContent={notification.length === 0 ? 0 : notification.length} color="primary" onClick={handleBadgeClick}>
                    <NotificationsOutlined color="action" />
                </Badge>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <Box className={classes.popover}>
                        <Typography variant="h6" className={classes.popoverTitle}>
                            Untracked Assets (1 min)
                        </Typography>
                        {
                            notification.length > 0 ? notification.map((obj, index) => {
                                // obj.ts = new Date(new Date(obj.ts).getTime()).toLocaleString()
                                return (
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ArrowDropDown />}
                                        aria-controls="panel2-content"
                                        id="panel2-header"
                                    >
                                        <Typography variant="subtitle1" className={classes.popoverContent} noWrap key={index}>
                                            <span>{index+1} : {obj?.name}</span>

                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                    <Typography className={classes.popoverContent} noWrap key={index}>
                                                    <span>Last Connected: </span>
                                                    <span>{notification[index].ts}</span>
                                                </Typography>
                                        {/* {
                                            notification.length > 0 && notification.map((obje, index)  =>
                                                 (
                                            
                                            ))
                                        } */}
                                    </AccordionDetails>
                                </Accordion>
                            )

                            } ) : <Typography variant="subtitle1" className={classes.popoverContent} noWrap>No Content</Typography>
                        }
                    </Box>
                </Popover>
            </div>
            {currentUser?.multiFactor?.user?.photoURL ? <Avatar sizes='12' src={currentUser?.multiFactor?.user?.photoURL} className={classes.avatar} /> : <Avatar sizes='12' className={classes.avatar} />}
            <div style={{ paddingLeft: 6 }} />
            <Typography variant={"h8"} noWrap style={{ color: '#fffdfd' }}>
                {currentUser?.multiFactor?.user?.displayName}
            </Typography>
            <IconButton aria-label="delete" color="default" onClick={handleLogout}>
                <ExitToAppIcon style={{ color: '#50c1e9', height: 45, width: 35 }} />
            </IconButton>
        </>
    );
};

PrivateHeader.propTypes = {
    classes: PropTypes.shape({}).isRequired,
};

export default withStyles(styles)(PrivateHeader);
